import { Box, Typography } from '@mui/material';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { ReactComponent as LogoMobile } from 'src/assets/svg/header-logo-mobile.svg';
import { ReactComponent as LogoDesktop } from 'src/assets/svg/header-logo-desktop.svg';
import { ReactComponent as LogoHos } from 'src/assets/svg/header-hos-logo.svg';
import { LanguageSelect } from 'src/components/language-select';
import { selectUserLoggedIn } from 'src/store/slices/user-slice';
import { LoginDialog } from 'src/features/login-dialog/login-dialog';
import { LogoutDropdown } from 'src/components/logout-dropdown';
import { getTheme } from 'src/utils/getTheme';
import { routes } from 'src/constants/routes';

import { styles } from './styles';

export const Header: FC = () => {
    const { t } = useTranslation();
    const userLoggedIn = useSelector(selectUserLoggedIn);
    const [isLoginDialogOpen, setIsLoginDialogOpen] = useState<boolean>(false);
    const [showPasswordReset, setShowPasswordReset] = useState<boolean>(false);
    const { isHosTheme } = getTheme();

    const handleLoginClick = () => {
        setIsLoginDialogOpen(true);
    };

    const handleCloseLoginDialog = () => {
        setIsLoginDialogOpen(false);
        setShowPasswordReset(false);
    };

    const handleShowPasswordReset = () => {
        setShowPasswordReset(!showPasswordReset);
    };

    const Logo = !isHosTheme ? (
        <>
            <LogoMobile css={styles.logoMobile} />
            <LogoDesktop css={styles.logoDesktop} />
        </>
    ) : (
        <>
            <LogoHos css={styles.logoMobile} />
            <LogoHos css={styles.logoDesktop} />
        </>
    );

    return (
        <Box css={styles.container}>
            {Logo}
            <Box css={styles.rightSide}>
                <LanguageSelect />
                {userLoggedIn ? (
                    <LogoutDropdown />
                ) : (
                    <Typography variant="h4" css={styles.loginText} onClick={handleLoginClick}>
                        {t('header_login')}
                    </Typography>
                )}
                <LoginDialog
                    open={isLoginDialogOpen}
                    closeFn={handleCloseLoginDialog}
                    showPasswordReset={showPasswordReset}
                    handleShowPasswordReset={handleShowPasswordReset}
                    currentEmail={null}
                    redirectUrl={`${window.location.origin}${routes.callback.index}`}
                />
            </Box>
        </Box>
    );
};
